<script setup>
import {nextTick, ref} from 'vue'
import {v4 as uuidv4} from 'uuid'
import QRCode from "qrcode";
import config from '@/config/config'
import CustomMask from "@/components/NewPC/CustomMask.vue";
import {delPlayerInfoFun, getPlayerInfoFun} from "@/api/common";
import {delay} from "@/utils/delay";
import {useTgaStore} from "@/store/tga";
const tga = useTgaStore()
const emits = defineEmits(['echoPlayerInfo'])
const clearHttpClient = ref(false)

const CustomMaskRef = ref(null);
const QrcodeRef = ref(null);
const open = (status) => {
  clearHttpClient.value = false
  CustomMaskRef.value?.open();
  if (status == true) {
    // 生成uuid
    const uuid = uuidv4().replace(/-/g, '')
    const appid = "wx1b5924b6b5f76cc4"
    let _path = 'top-up'
    _path = _path.split('?')[0]
    const redirect_uri = encodeURIComponent(`${config.wechatAuth}?callback=${_path}&uuid=${uuid}`)
    try {
      nextTick(() => {
        QRCode.toCanvas(QrcodeRef.value, "https://jqhw-download.racoondigi.cn/campaigns_gzip/h5/payment/wechat/step1_test/index.html?appid=" + appid + "&scope=snsapi_userinfo" + "&redirect_uri=" + redirect_uri, {
          width:  130, // 设置二维码宽度
          margin: 2,  // 设置二维码边距
          color: {
            dark: '#000000', // 二维码颜色
            light: '#ffffff', // 背景色
          },
        });
        getPlayerInfo(uuid)
        // 循环刷新，根据uuid获取玩家信息
      })
    } catch (err) {
      console.error('Failed to generate QR code:', err);
    }
  }

  if (status == 'click') {
    clearHttpClient.value = true
  }
}
/**
 * 递归查询用户信息
 * @param uuid
 */
const getPlayerInfo = async (uuid) => {
  const res = await getPlayerInfoFun(uuid)
  if (res.status == 200 && res.data.code == 0) {
    delPlayerInfo(uuid)
    // 将玩家信息存储
    emits('echoPlayerInfo', {...res.data.data, notClosed: true})
    open();
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_login',
      account: res.data.playerInfo.account,
      gps1: '点击微信登录',
      gps2: '成功'
    })
  } else {
    // 休眠
    await delay(1000);
    if (!clearHttpClient.value) {
      await getPlayerInfo(uuid)
    }
  }
}
/**
 * 查询结束后删除用户信息
 * @param uuid
 */
const delPlayerInfo = (uuid) => {
  delPlayerInfoFun(uuid)
}


defineExpose({
  open
})
</script>

<template>
<custom-mask ref="CustomMaskRef">
  <div class="content_block">
    <img src="@/assets/newPc/topup/login_dialog_close.png" alt="" class="close_icon" @click="open('click')">
    <div class="title">微信登录</div>
    <canvas ref="QrcodeRef" class="qrcode"></canvas>
    <div class="desc">
      <div>请使用微信扫一扫登录</div>
      <div>《街球艺术》官网</div>
    </div>
  </div>
</custom-mask>
</template>

<style scoped lang="scss">
.content_block {
  width: 15.390625vw;
  height: 19.375vw;
  background: transparent url("@/assets/newPc/topup/wechat_login_bg.png") no-repeat center center;
  background-size: contain;
  position: relative;
  padding: 1.4453125vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #FF9120;
    text-align: center;
    line-height: 1;
    font-size: 1.171875vw;
  }
  .close_icon {
    position: absolute;
    top: 0.703125vw;
    right: 0.625vw;
    width: 1.6015625vw;
    height: 1.6015625vw;
  }
  .qrcode {
    background-color: #fff;
    width: 8.75vw;
    height: 8.75vw;
    margin: 1.875vw auto 1.9921875vw;
  }
  .desc {
    color: #6B6660;
    font-size: 0.78125vw;
    text-align: center;
  }
}
</style>